export function anonymizeName(name: string): string {
  if (!name) return '';
  return `${name.charAt(0)}${'*'.repeat(Math.max(2, name.length - 1))}`;
}

export function anonymizeCompanyName(name: string): string {
  if (!name) return '';
  const words = name.split(' ');
  return words.map(word => anonymizeName(word)).join(' ');
}

export function anonymizeEmail(email: string): string {
  if (!email) return '';
  const [localPart, domain] = email.split('@');
  if (!domain) return anonymizeName(email);
  
  return `${localPart.charAt(0)}${'*'.repeat(Math.max(2, localPart.length - 1))}@${domain}`;
}

export function useAnonymization(value: string, type: 'name' | 'email' | 'company', shouldAnonymize: boolean): string {
  if (!shouldAnonymize || !value) return value;
  switch (type) {
    case 'name':
      return anonymizeName(value);
    case 'email':
      return anonymizeEmail(value);
    case 'company':
      return anonymizeCompanyName(value);
    default:
      return value;
  }
}